import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';
import { exportAnalytics } from '../../../../utils/Export/exportUtils';
import  AdminAnalyticsHelper from '../../../../utils/API/BackendHelper/admin/analytics';

// Selector to get analytics data from state
const getAnalyticsData = (state) => state.adminAnalytics.systemAnalytics;

// Worker Sagas
function* fetchSystemAnalyticsSaga(forceRefresh = false) {
  try {
    // Use AdminAnalyticsHelper instead of axios
    const response = yield call([AdminAnalyticsHelper, 'getSystemAnalytics'], forceRefresh === true);
    
    if (response.success) {
      yield put(actions.fetchSystemAnalyticsSuccess(response.data));
    } else {
      yield put(actions.fetchSystemAnalyticsFailure(response.message || 'Failed to fetch analytics'));
    }
  } catch (error) {
    console.error('Fetch system analytics saga error:', error);
    
    const errorMessage = error.message || 'Failed to fetch system analytics';
    
    yield put(actions.fetchSystemAnalyticsFailure(errorMessage));
  }
}

function* exportAnalyticsSaga(action) {
  try {
    const format = action.payload; // 'excel' or 'pdf'
    
    // Get analytics data from Redux store
    const analyticsData = yield select(getAnalyticsData);
    
    if (!analyticsData || !analyticsData.overview) {
      throw new Error('No analytics data available. Please load data first.');
    }
    
    // Export using frontend utility
    const result = yield call(exportAnalytics, analyticsData, format);
    
    if (result.success) {
      yield put(actions.exportAnalyticsSuccess({ 
        format, 
        timestamp: new Date().toISOString(),
        message: result.message
      }));
    } else {
      throw new Error(result.error || 'Export failed');
    }
  } catch (error) {
    console.error('Export analytics saga error:', error);
    
    const errorMessage = error.message || 'Failed to export analytics';
    
    yield put(actions.exportAnalyticsFailure(errorMessage));
    
    // Show error notification
    alert(`Export failed: ${errorMessage}`);
  }
}

function* refreshAnalyticsSaga() {
  // Refresh bypasses the backend cache
  yield call(fetchSystemAnalyticsSaga, true);
}

// Watcher Saga
function* adminAnalyticsSaga() {
  yield takeLatest(types.FETCH_SYSTEM_ANALYTICS_REQUEST, fetchSystemAnalyticsSaga);
  yield takeEvery(types.EXPORT_ANALYTICS_REQUEST, exportAnalyticsSaga);
  yield takeLatest(types.REFRESH_ANALYTICS_REQUEST, refreshAnalyticsSaga);
}

export default adminAnalyticsSaga;